export { dictionaryIds } from '@shared/constants';

export const moduleName = 'dict';

export const summitId = 22;
